const rules = {
  TelephoneNumber: {
    regex: '[0-9]{11}',
    maxLength: 11,
    minLength: 11
  },
  AccountNumber: {
    regex: '[0-9]{8,11}',
    maxLength: 11,
    minLength: 8
  },
  SortCode: {
    regex: '[0-9]{6}',
    maxLength: 6,
    minLength: 6
  }
};

export const validateAccountNumber = (accountNumber = '') =>
  new RegExp(rules.AccountNumber.regex).test(accountNumber) &&
  accountNumber.length <= rules.AccountNumber.maxLength &&
  accountNumber.length >= rules.AccountNumber.minLength;

export const validateSortCode = (sortCode) =>
  new RegExp(/^(05|82)-[0-9]{2}-[0-9]{2}$/).test(sortCode) &&
  sortCode.length <= 8 &&
  sortCode.length >= 8;

export const validateMobileNumber = (mobileNumnber) =>
  new RegExp(rules.TelephoneNumber.regex).test(mobileNumnber) &&
  mobileNumnber.length <= rules.TelephoneNumber.maxLength &&
  mobileNumnber.length >= rules.TelephoneNumber.minLength;

export const validations = {
  sortCode: validateSortCode,
  accountNumber: validateAccountNumber,
  mobileNumber: validateMobileNumber
};
